import { useState, createContext } from 'react';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import ListingLibLabelCell from 'framework-listing-lib/table/ListingLibLabelCell';
import UIList from 'UIComponents/list/UIList';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { FormStatus, FormType } from 'FormsUI/components/dashboard/frameworkTable/types';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
import HoverContent from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/name/HoverContent';
import NameLink from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/name/NameLink';
import FormsStatusTag from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/name/FormsStatusTag';

// @ts-expect-error untyped dependency
import WarningTag from 'content-label-lib/components/WarningTag';
import ComparePql from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/name/HoverContent/actions/ComparePql';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ComparePqlContext = /*#__PURE__*/createContext(() => {});
function NameCell({
  crmObject,
  tdProps
}) {
  const propertyValue = getPropertyValue(crmObject, PROPERTIES.NAME);
  const formId = getPropertyValue(crmObject, PROPERTIES.FORM_ID);
  const folderId = getPropertyValue(crmObject, PROPERTIES.FOLDER_ID);
  const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
  const businessUnitId = Number(getPropertyValue(crmObject, PROPERTIES.BUSINESS_UNIT_IDS));
  const cloneable = getPropertyValue(crmObject, PROPERTIES.CLONEABLE) === 'true';
  const editable = getPropertyValue(crmObject, PROPERTIES.EDITABLE) === 'true';
  const deletable = getPropertyValue(crmObject, PROPERTIES.DELETABLE) === 'true';
  const status = getPropertyValue(crmObject, PROPERTIES.STATUS);
  const isPublished = status === FormStatus.PUBLISHED;
  const isBeta = getPropertyValue(crmObject, PROPERTIES.EMBED_VERSION) === EmbedVersions.V3;
  const isNewEditor = getPropertyValue(crmObject, PROPERTIES.EMBED_VERSION) === EmbedVersions.V4;
  const isLegacy = formType === FormType.HUBSPOT && getPropertyValue(crmObject, PROPERTIES.EMBED_VERSION) !== EmbedVersions.V4;
  const [isShowingComparePql, setIsShowingComparePql] = useState(false);
  const hoverContent = /*#__PURE__*/_jsx(HoverContent, {
    crmObject: crmObject,
    formId: formId,
    folderId: folderId,
    formType: formType,
    formStatus: status,
    name: propertyValue,
    businessUnitId: businessUnitId,
    cloneable: cloneable,
    editable: editable,
    deletable: deletable
  });
  return /*#__PURE__*/_jsxs(ComparePqlContext.Provider, {
    value: setIsShowingComparePql,
    children: [/*#__PURE__*/_jsx(ListingLibLabelCell, Object.assign({
      hoverContent: hoverContent
    }, tdProps, {
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsx(WarningTag, {
          contentId: formId,
          keyWord: "form",
          isPublished: isPublished
        }), /*#__PURE__*/_jsx(NameLink, {
          name: propertyValue,
          formId: formId,
          formType: formType,
          isPublished: isPublished
        }), /*#__PURE__*/_jsx(FormsStatusTag, {
          isFormTypeShown: true,
          status: status,
          formType: formType,
          isPublished: isPublished,
          isBeta: isBeta,
          isNewEditor: isNewEditor,
          isLegacy: isLegacy
        })]
      })
    })), isShowingComparePql && /*#__PURE__*/_jsx(ComparePql, {})]
  });
}
export const name = {
  width: 455,
  hoverCell: true,
  renderCell: props => /*#__PURE__*/_jsx(NameCell, Object.assign({}, props))
};